import React from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import { LANGUAGES_KEYS } from "@constants/global.constants";

const LanguageSwitcher: React.FC = () => {
	const { i18n, t } = useTranslation();
	const isEnglish = (i18n.language || LANGUAGES_KEYS.en).toLowerCase().startsWith(LANGUAGES_KEYS.en);

	const handleLanguageChange = () => {
		const newLanguage = isEnglish ? LANGUAGES_KEYS.ur : LANGUAGES_KEYS.en;
		void i18n.changeLanguage(newLanguage);
		localStorage.setItem("preferredLanguage", newLanguage);
	};

	const currentLanguage = isEnglish
		? t("common.language.englishWithFlag")
		: t("common.language.urduWithFlag");
	const switchToLanguage = isEnglish ? t("common.language.urdu") : t("common.language.english");

	return (
		<Tooltip title={t("common.language.switchLanguage")} arrow>
			<button
				type="button"
				onClick={handleLanguageChange}
				className="flex items-center gap-2 w-full px-3 py-2 rounded-lg hover:bg-accent-40 hover:text-accent transition-colors duration-150 text-gray-900 font-medium"
				aria-label={t("common.language.switchTo", { language: switchToLanguage })}
			>
				<LanguageRoundedIcon color="success" />
				<span className="text-sm">{currentLanguage}</span>
			</button>
		</Tooltip>
	);
};

export default LanguageSwitcher;
